import { CameraAngles, IAsset, Nil, SwingPosition } from '@core';

import * as css from './PositionImage.css';

type PositionImageProps = {
    images: IAsset[] | Nil;
    angle?: CameraAngles;
    position?: SwingPosition | null;
};

export const PositionImage = ({ images, angle = 'down_the_line', position }: PositionImageProps) => {
    const frameUrl = images?.find((image) => image.name === `${angle}.${position}`)?.url;
    return (
        <div className={css.frame({ showFallback: !!frameUrl })}>
            {frameUrl && <img src={frameUrl} className={css.frameImg} alt="" />}
        </div>
    );
};
